import React from 'react';
import {useAuthContext} from './index';

function withAuth(WrappedComponent) {
	return function WithAuth(props) {
		const auth = useAuthContext();
		return <WrappedComponent {...props} {...auth} />;
	};
}

export default withAuth;
